<template>
    <div>
        <div class="device-box r200-bg">
            <h3 class="device-name reveal-bottom">R500-X8S</h3>
            <p class="device-desc reveal-bottom">{{ $t("dv.rt") }}</p>
            <img class="r200-img reveal-bottom" :src="r200" alt="r200" />
        </div>
        <div
            class="device-box bg-fixed"
            :style="{
                backgroundImage: 'url(' + bg2 + ')',
            }"
        >
            <div class="wrap">
                <div class="device-title reveal-bottom">
                    {{ $t("dv.rt1") }}<br />
                    {{ $t("dv.rt2") }}
                </div>
                <div class="device-char">
                    <div class="device-char-item reveal-bottom">
                        <img
                            :src="intro2"
                            alt="intro1"
                            class="device-char-icon"
                            style="height:50px"
                        />
                        <div class="device-char-desc">
                            <h4 class="device-chart-desc-titl">
                                {{ $t("dv.rd1") }}
                            </h4>
                            <div class="device-chart-desc-cont">
                                2.5<span style="font-size:18px">Gbps</span>
                            </div>
                        </div>
                    </div>
                    <div
                        class="device-char-item reveal-bottom"
                        style="width:229px;"
                    >
                        <img
                            :src="intro3"
                            alt="intro1"
                            class="device-char-icon"
                            style="height:50px"
                        />
                        <div class="device-char-desc">
                            <h4 class="device-chart-desc-titl">
                                {{ $t("dv.rd2") }}
                            </h4>
                            <div class="device-chart-desc-cont">
                                10<span style="font-size:18px">Gbps</span>
                            </div>
                        </div>
                    </div>
                    <div class="device-char-item reveal-bottom">
                        <img
                            :src="intro4"
                            alt="intro1"
                            class="device-char-icon"
                            style="height:50px"
                        />
                        <div class="device-char-desc">
                            <h4 class="device-chart-desc-titl">
                                {{ $t("dv.rd3") }}
                            </h4>
                            <div class="device-chart-desc-cont">
                                {{ $t("dv.rxs") }}
                            </div>
                            <div class="device-chart-desc-detail"></div>
                        </div>
                    </div>
                    <div
                        class="device-char-item reveal-bottom"
                        style="width:229px"
                    >
                        <img
                            :src="intro6"
                            alt="intro1"
                            class="device-char-icon"
                            style="height:50px"
                        />
                        <div class="device-char-desc">
                            <h4 class="device-chart-desc-titl">
                                {{ $t("dv.rd4") }}
                            </h4>

                            <div class="device-chart-desc-detail">
                                Console x1<br />
                                USB2.0 x2<br />
                                Gbps RJ45 x6<br />
                                10Gbps SPF x2
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="device-box">
            <div class="card-box reveal-bottom">
                <div class="card  r200">
                    <div class="card-head">
                        <div class="card-head-left">
                            <span>{{ $t("dv.ry") }}</span>
                            <div></div>
                        </div>
                        <div class="card-no">1</div>
                    </div>
                    <div
                        class="card-text"
                        :style="lang === 'en_US' ? 'font-size:25px' : ''"
                    >
                        {{ $t("dv.ryc") }}<br />{{ $t("dv.ryc1") }}
                    </div>
                </div>
                <div class="card r200">
                    <div class="card-head">
                        <div class="card-head-left">
                            <span>{{ $t("dv.ru") }}</span>
                            <div></div>
                        </div>
                        <div class="card-no">2</div>
                    </div>
                    <div
                        class="card-text"
                        :style="lang === 'en_US' ? 'font-size:25px' : ''"
                    >
                        15000 {{ $t("dv.rxu") }}
                    </div>
                </div>
                <div class="card r200">
                    <div class="card-head">
                        <div class="card-head-left">
                            <span>{{ $t("dv.ra") }}</span>
                            <div></div>
                        </div>
                        <div class="card-no">3</div>
                    </div>
                    <div
                        class="card-text"
                        :style="lang === 'en_US' ? 'font-size:25px' : ''"
                    >
                        {{ $t("dv.rac") }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import initAnimation from "../animation";
export default {
    name: "R200",
    data() {
        return {
            lang: localStorage.getItem("lang"),
            bg2: require("@/assets/images/devices/S200_bg.jpg"),
            r200: require("@/assets/images/devices/R.png"),
            intro1: require("@/assets/images/devices/R200_intro1.png"),
            intro2: require("@/assets/images/devices/R200_intro2.png"),
            intro3: require("@/assets/images/devices/R200_intro3.png"),
            intro4: require("@/assets/images/devices/R200_intro4.png"),
            intro5: require("@/assets/images/devices/R200_intro5.png"),
            intro6: require("@/assets/images/devices/R200_intro6.png"),
        };
    },
    mounted() {
        setTimeout(initAnimation, 0);
        this.$bus.$on("lang", (lang) => {
            this.lang = lang;
        });
    },
};
</script>
<style scoped>
@import "./devices.css";
.r200-img {
    width: 753px;
    /* height: 496px; */
    margin: 77px auto 0;
    display: block;
}
.r200-bg {
    background: linear-gradient(left top, #d6acff, #a75fed);
}
.r200:hover {
    background-color: #a75fed;
    transition: all 0.3s ease;
}
</style>



// WEBPACK FOOTER //
// src/Pages/Hardware/R500X8S.vue